import { Divider } from "@mui/material";
import { BaseInput, Ptag } from "components/core";
import React, { Fragment, useEffect, useState } from "react";
import { AttributeDetailWrapper, Error, TableGrid } from "../styles";
import BaseTickBox from "../TickBox";
import { colors } from "theme";
import BaseSwitch from "../BaseSwitch";

const HEADERS = [
  "Select Attribute",
  "For Employee Selection",
  "For Display",
  "None",
  "Dependent Sensitive"
];

const AttributesTable = ({ attributes, formikProps, attrDescriptionError, onAttrChange, dependentSensitive }) => {
  const [selected, setSelected] = useState({});
  const [sensitive, setSensitive] = useState(attributes?.reduce((acc, item) => ({ ...acc, [item]: false }), {}));
  const onChange = (event, attribute, type) => {
    const { checked } = event.target;
    setSelected((prev) => ({
      ...prev,
      [attribute]: checked ? type : null,
    }));
  };
  const onSwitch = (event, attribute) => {
    console.log("onswitch clicked", sensitive[attribute], attribute)
    const { checked } = event.target;
    setSensitive((prev)=>({
      ...prev,
      [attribute]:checked,
    }))
  }
  console.log(sensitive)
  useEffect(()=>{
    onAttrChange(selected)
  }, [selected]);
  useEffect(()=>{
    dependentSensitive(sensitive)
  }, [sensitive]);
  const renderCheckbox = (index, attribute, type) => {
    return (
      <BaseTickBox
        fontSize={12}
        key={index}
        selected={selected[attribute] === type}
        onChange={(event) => onChange(event, attribute, type)}
      />
    );
  };
  const renderSwitchBox = (index, attribute, type) => {
    return (
      <BaseSwitch
        key={index}
        selected={sensitive[attribute]}
        onChange={(event)=>onSwitch(event, attribute)}
      />
    )
  }

  return (
    <>
      <Divider />
      <Ptag fontSize="20px" fontWeight="500" marginTop="50px">
        Employee Select Attributes
      </Ptag>
      <div style={{ margin: "1rem 0 3rem 0" }}>
        <Ptag fontSize="14px" fontWeight="400">
          Please select attributes that will be made available to your employees
          for selection and upgrades
        </Ptag>
      </div>
      <TableGrid>
        {HEADERS.map((header) => (
          <Ptag fontWeight="400">{header}</Ptag>
        ))}
        {attributes.map((attribute, index) => {
          if(attribute === "Age Band") return;
          return (
            <Fragment key={index}>
              <Ptag color={colors.primaryColor}>{attribute}</Ptag>
              {renderCheckbox(index, attribute, 0)}
              {renderCheckbox(index, attribute, 1)}
              {renderCheckbox(index, attribute, 2)}
              {renderSwitchBox(index, attribute)}
              {(selected[attribute] != null) && ((selected[attribute])!== 2) && <AttributeDetailWrapper>
                <BaseInput
                  label="Define Attribute"
                  fontSize="16px !important"
                  variant="standard"
                  formikProps={{
                    ...formikProps,
                    name: `attribute_definition_mapping.${attribute}`,
                  }}
                />
                {/* {attrDescriptionError.includes(attribute) && (
                  <Error>Required*</Error>
                )} */}
              </AttributeDetailWrapper>}
            </Fragment>
          );
        })}
      </TableGrid>
    </>
  );
};

export default AttributesTable;
